import { CheckCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import SignupNudgeCard from '../SignupNudgeCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Success card shown after a successful RSVP submit. Branches for waitlisted
 * (no QR yet — promoter must approve) vs confirmed (QR + download button).
 *
 * Props:
 *   result     — the POST /rsvp/{code} response (id, status, slot_number, email, phone)
 *   info       — the /rsvp/{code} lookup response (event_title)
 *   qrDataUri  — data URI of the QR PNG, null while loading or for waitlisted guests
 */
export default function RsvpSuccessCard({ result, info, qrDataUri }) {
  const { user } = useAuth();
  const isWaitlist = result.status === 'waitlisted';
  return (
    <div
      className="border border-[#B5FF00]/40 bg-[#B5FF00]/5 p-8 text-center"
      data-testid="rsvp-success"
    >
      <CheckCircle size={48} className="text-[#B5FF00] mx-auto mb-4" />
      <h2 className="font-['Josefin_Sans'] text-3xl text-white mb-3">
        YOU&apos;RE ON THE LIST
      </h2>
      <p className="text-zinc-300 mb-4">
        {isWaitlist
          ? 'You\u2019re on the wait list. The promoter will review + confirm — you\u2019ll get a QR code by WhatsApp/email once approved.'
          : 'See you at the door. Bring valid ID and show the QR below.'}
      </p>
      <div className="inline-block bg-[#B5FF00] text-[#050505] font-bold tracking-widest px-6 py-3 mb-4">
        {isWaitlist ? 'WAITLIST' : `SLOT #${result.slot_number}`}
      </div>
      {qrDataUri && !isWaitlist && (
        <div className="mt-4 flex flex-col items-center" data-testid="rsvp-qr">
          <div className="bg-white p-4 inline-block">
            <img
              src={qrDataUri}
              alt="Entry QR"
              className="w-64 h-64 sm:w-72 sm:h-72 block"
            />
          </div>
          <a
            href={`${API}/rsvp/qr/${result.id}.png`}
            download={`unight-${info.event_title || 'rsvp'}-${result.slot_number || result.id}.png`}
            className="btn-primary mt-4 inline-flex items-center gap-2"
            data-testid="rsvp-download-qr-btn"
          >
            DOWNLOAD QR
          </a>
          <p className="text-zinc-500 font-mono text-xs mt-3 tracking-wider">
            SCAN AT THE DOOR · SAVE OR DOWNLOAD
          </p>
        </div>
      )}
      <p className="text-zinc-500 font-mono text-xs mt-4 tracking-wider">
        Confirmation sent to <span className="text-zinc-300">{result.email}</span> and WhatsApp on{' '}
        <span className="text-zinc-300">{result.phone}</span>.
      </p>
      {!user && (
        <SignupNudgeCard email={result.email} name={result.name} context="rsvp" />
      )}
    </div>
  );
}
